import { all, takeLatest } from 'redux-saga/effects';

import { companyActions } from '../index';
import create from './create';

const companySagas = all([takeLatest(companyActions.createRequest, create)]);

export default companySagas;
